"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.WarningTypes = exports.WarningRow = exports.Warning = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var Warning = /*#__PURE__*/(0, _createClass2["default"])(function Warning(type, level, description, data) {
  (0, _classCallCheck2["default"])(this, Warning);
  this.type = type;
  this.level = level;
  this.description = description;
  this.data = data;
});
exports.Warning = Warning;
var WarningTypes;
exports.WarningTypes = WarningTypes;
(function (WarningTypes) {
  WarningTypes[WarningTypes["BOX_INTERSECTION"] = 0] = "BOX_INTERSECTION";
  WarningTypes[WarningTypes["WALL_INTERSECTION"] = 1] = "WALL_INTERSECTION";
  WarningTypes[WarningTypes["ITEM_NOT_INSERTED"] = 2] = "ITEM_NOT_INSERTED";
  WarningTypes[WarningTypes["FAR_FROM_ORIGIN"] = 3] = "FAR_FROM_ORIGIN";
  WarningTypes[WarningTypes["ITEM_WARNING"] = 4] = "ITEM_WARNING";
})(WarningTypes || (exports.WarningTypes = WarningTypes = {}));
var WarningRow = /*#__PURE__*/(0, _createClass2["default"])(function WarningRow() {
  (0, _classCallCheck2["default"])(this, WarningRow);
  this.idItem = null;
});
exports.WarningRow = WarningRow;
//# sourceMappingURL=Warning.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/Warning.js
// module id = 489
// module chunks = 142